import { StatusLogbookDeliveries } from '../../logbook/conf/Data.conf';
import { indigo } from '@mui/material/colors';
import CancelIcon from '@mui/icons-material/Cancel';
import MuiTypography from '@mui/material/Typography';
import { Stack, Box } from '@mui/system';
import _ from 'lodash';
import RectangleChip from '../../../components/common/RectangleChip.component';
import { IconButton, Tooltip } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

const formatValue = (key, value) => {
  switch (key) {
    case 'product':
      const product = value?.id_item?.data?.attributes;
      return (
        <Stack>
          {product?.name_ITA || product?.name_ENG}
          {value?.note && (
            <Box>
              <MuiTypography
                variant='body2'
                sx={{
                  display: 'inline',
                  fontWeight: 'bold',
                  backgroundColor: indigo[50],
                  color: indigo[500],
                }}
              >{`Note: `}</MuiTypography>
              <MuiTypography
                variant='body2'
                sx={{
                  display: 'inline',
                  backgroundColor: indigo[50],
                  color: indigo[500],
                }}
              >
                {value?.note}
              </MuiTypography>
            </Box>
          )}

          {value?.internal_note && (
            <Box>
              <MuiTypography
                variant='body2'
                sx={{
                  display: 'inline',
                  fontWeight: 'bold',
                  backgroundColor: indigo[50],
                  color: indigo[500],
                }}
              >{`Internal Note: `}</MuiTypography>
              <MuiTypography
                variant='body2'
                sx={{
                  display: 'inline',
                  backgroundColor: indigo[50],
                  color: indigo[500],
                }}
              >
                {value?.internal_note}
              </MuiTypography>
            </Box>
          )}
        </Stack>
      );

    case 'quantity':
      return `${value?.quantity || '-'} ${value?.quantity_type || ''}`;

    case 'id_logbook':
      const color = _.find(
        StatusLogbookDeliveries,
        (element) => element.label.toUpperCase() === value?.toUpperCase()
      );
      return value ? (
        <RectangleChip
          value={value}
          color={color?.color}
          backgroundColor={color?.backgroundColor}
        />
      ) : (
        <CancelIcon color='error' />
      );

    case 'id_supplier':
      return value ? `${value?.mexal_code} -  ${value?.company_name}` : '-';

    case 'product_overview':
      const product_overview = value?.id_item?.data?.attributes;
      return (
        <Stack>
          {product_overview?.name_ITA || product_overview?.name_ENG}
          {value?.note && (
            <Box>
              <MuiTypography
                variant='body2'
                sx={{
                  display: 'inline',
                  fontWeight: 'bold',
                  backgroundColor: indigo[50],
                  color: indigo[500],
                }}
              >{`Note: `}</MuiTypography>
              <MuiTypography
                variant='body2'
                sx={{
                  display: 'inline',
                  backgroundColor: indigo[50],
                  color: indigo[500],
                }}
              >
                {value?.note}
              </MuiTypography>
            </Box>
          )}
        </Stack>
      );

    case 'view_order':
      return (
        value && (
          <Tooltip title='View Order'>
            <IconButton color='primary'>
              <ReceiptLongIcon />
            </IconButton>
          </Tooltip>
        )
      );
    default:
      return value || '-';
  }
};
export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 25,
    },
    sort: {
      by: 'id_logbook.id_supplier.company_name',
      direction: 'asc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],

  columns: [
    {
      label: 'PRODUCT',
      key: 'product_overview',
      id: 'attributes',
      sort_key: 'id_item.name_ITA',
      sortable: true,
      width: 650,
    },
    {
      id: 'attributes',
      label: 'QUANTITY',
      key: 'quantity',
      sort_key: 'quantity',
      sortable: true,
    },
    {
      id: 'attributes.available',
      label: 'AVAILABLE',
      key: 'available',
      sort_key: 'available',
      sortable: true,
    },
    {
      id: 'attributes.internal_note',
      label: 'INTERNAL NOTE',
      key: 'internal_note',
      sort_key: 'internal_note',
      sortable: true,
    },
    {
      label: 'LOGBOOK',
      key: 'id_logbook',
      id: 'attributes.id_logbook.data.attributes.status_logbook',
      sort_key: 'id_logbook.status_logbook',
      sortable: true,
      width: 150,
    },
    {
      label: 'SUPPLIER',
      key: 'id_supplier',
      id: 'attributes.id_logbook.data.attributes.id_supplier.data.attributes',
      sort_key: 'id_logbook.id_supplier.company_name',
      sortable: true,
    },
    {
      label: '',
      key: 'view_order',
      id: 'attributes.id_logbook.data',
      width: 50,
    },
  ],
  render: {
    formatHead: (key, value) => {
      switch (key) {
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value) => {
      return formatValue(key, value);
    },
  },
};

export const ListAllItemsConf = {
  columns: [
    {
      label: 'PRODUCT',
      key: 'product',
      id: 'attributes',
      sort_key: 'id_item.name_ITA',
    },
    {
      id: 'attributes',
      label: 'QUANTITY',
      key: 'quantity',
      sort_key: 'quantity',
    },
    {
      label: 'LOGBOOK',
      key: 'id_logbook',
      id: 'attributes.id_logbook.data.attributes.status_logbook',
    },
    {
      label: 'SUPPLIER',
      key: 'id_supplier',
      id: 'attributes.id_logbook.data.attributes.id_supplier.data.attributes',
      sort_key: 'id_logbook.id_supplier.company_name',
    },
  ],
  render: {
    formatValue: (key, value) => {
      return formatValue(key, value);
    },
  },
};
